import {
  GraphQLList,
  GraphQLNonNull,
  GraphQLObjectType,
  GraphQLString
} from 'graphql'
import { Context } from '../shared'
import {
  ApplicationQueryArgs,
  applicationQueryArgs
} from '../types/application-query-args'
import { ContrastGraphQLFieldConfig } from '../index'

export interface ApplicationVulnerabilityTags {
  readonly tags: string[]
}

export const applicationVulnerabilityTagsType = new GraphQLObjectType({
  name: 'ApplicationVulnerabilityTags',
  fields: () => ({
    tags: {
      type: new GraphQLNonNull(
        new GraphQLList(new GraphQLNonNull(GraphQLString))
      )
    }
  })
})

export const applicationVulnerabilityTags: ContrastGraphQLFieldConfig<
  any,
  Context,
  ApplicationQueryArgs,
  ApplicationVulnerabilityTags
> = {
  description: 'Get all unique vulnerability tags by Application',
  type: applicationVulnerabilityTagsType,
  args: applicationQueryArgs,
  async resolve(_source, args, context) {
    const { organizationID, applicationID } = args
    const { connector } = context
    const { tags } = await connector.get(
      `/${organizationID}/tags/traces/application/${applicationID}`
    )
    return { tags }
  }
}
